import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";

const name = 'leezenCustomerManagement';

const initialState = {
    data: [],
    selection: [],
    pageNumber: 0,
    pageSize: 10,
    drafts: {},
    criteria: {},
    sort: null,
    selections1: {},
    selections2: {},
    selections3: {}
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
        setSelection(state, action) {
            state.selection = action.payload;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
        },
        setDrafts(state, action) {
            state.drafts = json.toJSON(action.payload);
        },
        setCriteria(state, action) {
            state.criteria = action.payload;
        },
        setSort(state, action) {
            state.sort = action.payload;
        },
        setSelections1(state, action) {
            state.selections1 = json.toJSON(action.payload);
        },
        setSelections2(state, action) {
            state.selections2 = json.toJSON(action.payload);
        },
        setSelections3(state, action) {
            state.selections3 = json.toJSON(action.payload);
        }
    }
})

export const { setData, setSelection, setPageNumber, setPageSize, setDrafts, setSort, setCriteria, setSelections1, setSelections2, setSelections3} = slice.actions;
export const { reducer } = slice;

export const selectData = state => json.fromJSON(state[name].data);
export const selectSelection = state => state[name].selection;
export const selectPageNumber = state => state[name].pageNumber;
export const selectPageSize = state => state[name].pageSize;
export const selectDrafts = state => json.fromJSON(state[name].drafts);
export const selectCriteria = state => state[name].criteria;
export const selectSort = state => state[name].sort;

export const selectDraft =  (key) => (state) => selectDrafts(state)[key];
export const setDraft = (key, draft) => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    drafts[key] = draft;
    dispatch(setDrafts(drafts));
}
export const selectSelections1 = state => json.fromJSON(state[name].selections1);
export const selectSelection1 =  (key) => (state) => selectSelections1(state)[key];
export const setSelection1 = (key, selection) => (dispatch, getState) => {
    const selections1 = selectSelections1(getState());
    selections1[key] = selection;
    dispatch(setSelections1(selections1));
}
export const selectSelections2 = state => json.fromJSON(state[name].selections2);
export const selectSelection2 =  (key) => (state) => selectSelections2(state)[key];
export const setSelection2 = (key, selection) => (dispatch, getState) => {
    const selections2 = selectSelections2(getState());
    selections2[key] = selection;
    dispatch(setSelections2(selections2));
}
export const selectSelections3 = state => json.fromJSON(state[name].selections3);
export const selectSelection3 =  (key) => (state) => selectSelections3(state)[key];
export const setSelection3 = (key, selection) => (dispatch, getState) => {
    const selections3 = selectSelections3(getState());
    selections3[key] = selection;
    dispatch(setSelections3(selections3));
}

export const removeDraft = key => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    delete drafts[key];
    dispatch(setDrafts(drafts));
}

const leezenCustomerManagementReducer = reducer;
export default leezenCustomerManagementReducer;